import React, { useContext, useState } from "react";
import parse from 'html-react-parser';
import "../App.css";
import { getText } from "../utils/languageUtils";
import LanguageContext from "./hooks/LanguageContext";

const ReadMoreResourcesShortLong = ({ data, language }) => {
	const [isReadMore, setIsReadMore] = useState(false);
	const { translations: translationData } = useContext(LanguageContext);
	const translations = translationData?.about || {};
	const toggleReadMore = () => {
		setIsReadMore(!isReadMore);
	};

	const readMoreText = getText(translations.read_more, language);
	const readLessText = getText(translations.read_less, language);
	
	return (
		<div className="text textP" style={{margin:0}}>
			{isReadMore === false ? parse(String(getText(data?.short_description, language)).replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")) : parse(String(getText(data?.long_description, language)).replace(/(<p[^>]+?>|<p>|<\/p>)/img, ""))}
			<span onClick={toggleReadMore} className="read-or-hide" style={{fontWeight: 400, color:"#792110"}}>
				{isReadMore === false ? ` ${readMoreText}` : ` ${readLessText}`}
			</span>
		</div>
	)
}


export default ReadMoreResourcesShortLong;
